import { useMutation, useQuery, useQueryClient } from 'react-query';
import { getBrightness, setSystemBrightness } from '../functions';

export const useBrightness = () => {
  const client = useQueryClient();

  const key = 'brightness';

  const data = useQuery(key, getBrightness);

  const setBrightness = useMutation(setSystemBrightness, {
    onSuccess(data) {
      client.setQueryData(key, data);
    },
  });

  return {
    data,
    setBrightness,
  };
};
